import React from "react";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";
import { Layout, Menu, Icon, Select } from "antd";
import logo from "../../assets/logo.png";
const { Sider } = Layout;
const Option = Select.Option;

const menuKeys = {
  "/admin/blog": "1",
  "/admin/profile": "2",
  "/admin/results": "3",
  "/admin/users": "4"
};

function SideBar(props) {
  return (
    <Sider
      style={{ textAlign: "left", borderRight: "1px solid #fff" }}
      breakpoint="lg"
      collapsedWidth="0"
    >
      <div style={{ textAlign: "center" }}>
        <Select
          labelInValue
          defaultValue={{ key: props.language }}
          value={{ key: props.language }}
          style={{ width: 120 }}
          onChange={({ key }) => props.changeLanguage(key)}
        >
          <Option value="dk">Dansk</Option>
          <Option value="en">English</Option>
        </Select>
      </div>

      <div className="logo" style={{ textAlign: "center", padding: "20px" }}>
        <Link to={"/"}>
          <img alt='side-bar' src={logo} height="70px" />
        </Link>
      </div>
      <Menu
        theme="dark"
        mode="inline"
        defaultSelectedKeys={menuKeys[props.match.path]}
      >
        <Menu.Item key="1">
          <Link to="/admin/blog">
            <Icon type="layout" />
            <span className="nav-text">Blog posts</span>
          </Link>
        </Menu.Item>

        <Menu.Item key="3">
          <Link to="/admin/results">
            <Icon type="upload" />
            <span className="nav-text">Surveys</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="4">
          <Link to="/admin/users">
            <Icon type="user" />
            <span className="nav-text">Users</span>
          </Link>
        </Menu.Item>
      </Menu>
    </Sider>
  );
}

export default withRouter(SideBar);



// WEBPACK FOOTER //
// ./src/components/SideBar/index.js